var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-bg", attrs: { "aria-hidden": "true" } },
    [
      _c("div", { staticClass: "page-bg-gradient" }),
      _c(
        "svg",
        {
          staticClass: "page-bg-grid",
          attrs: { xmlns: "http://www.w3.org/2000/svg" },
        },
        [
          _c("defs", [
            _c(
              "pattern",
              {
                attrs: {
                  id: "shoplazza-grid",
                  width: "40",
                  height: "40",
                  patternUnits: "userSpaceOnUse",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M 40 0 L 0 0 0 40",
                    fill: "none",
                    stroke: "#0f172a",
                    "stroke-width": "1",
                  },
                }),
              ]
            ),
          ]),
          _c("rect", {
            attrs: {
              width: "100%",
              height: "100%",
              fill: "url(#shoplazza-grid)",
            },
          }),
        ]
      ),
      _c("div", { staticClass: "page-bg-orb page-bg-orb-green" }),
      _c("div", { staticClass: "page-bg-orb page-bg-orb-blue" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }